import { useState } from 'react';

function useModal() {
  const [isOpen, setIsOpen] = useState(false);

  function onClose() {
    setIsOpen(false);
  }

  function onOpen() {
    setIsOpen(true);
  }

  return {
    isOpen,
    onClose,
    onOpen,
  };
}

export default useModal;
